import ExportsActions from 'pages/Exports/components/ExportsActions'
import { useMutation } from '@apollo/client'
import { PARCELS_UNDELIVERED_EXPORT } from 'graphql/exports/queries'
import { hasNoError } from 'globals/graphql'

interface IProps {
  onShowExportConfirmation: () => void
}

const ParcelsUndelivered = (props: IProps) => {
  const { onShowExportConfirmation } = props
  const [parcelUndeliveredExport] = useMutation(PARCELS_UNDELIVERED_EXPORT)

  const onExport = () =>
    parcelUndeliveredExport().then(hasNoError(() => onShowExportConfirmation()))


  return (
    <div>
      <ExportsActions
        noRangeDatePicker
        onExport={onExport}
      />
    </div>
  )
}

export default ParcelsUndelivered
